import { $definitions } from 'ziphy-web-shared/basic/entities/notes/definitions';
export const getAutoGeneratedAjvSchema = (variant, builder) => {
    if (variant === 'ros') {
        const autoGeneratedAjvSchema = {
            type: 'object',
            properties: {},
        };
        const topSelectId = builder.variables.top_select_id;
        const topSelects = Object.values($definitions.selects.valuesMap(topSelectId));
        const isMale = topSelectId.includes('_male');
        const isFemale = topSelectId.includes('_female');
        const isNa = !isMale && !isFemale;
        for (const item of topSelects) {
            const schema = {
                type: 'object',
                properties: {},
                required: [],
            };
            const selectId = 'ros_' + item.code;
            const selects = Object.values($definitions.selects.valuesMap(selectId));
            for (const subItem of selects) {
                if (subItem.code === 'other') {
                    schema.properties[subItem.code] = { type: 'string', minLength: 1 };
                }
                else {
                    schema.properties[subItem.code] = { type: 'boolean' };
                    const isOptional = (item.code === 'breast' && !isFemale) ||
                        (item.code === 'genital_tract_male' && !isMale) ||
                        (item.code === 'genital_tract_female' && !isFemale);
                    if (!isOptional) {
                        schema.required.push(subItem.code);
                    }
                }
            }
            autoGeneratedAjvSchema.properties[item.code] = schema;
        }
        return autoGeneratedAjvSchema;
    }
    return null;
};
